
































import {Vue, Component, Prop, Emit} from "vue-property-decorator";
import RestcommNumbers from "@/consoleapi/api/restcomm/numbers";
import ResponseMessenger from "@/consoleapi/messages/responseMessenger";
import CreateIncomingPhoneNumberModal from "@/components/numbers/CreateIncomingPhoneNumberModal.vue";

interface AppliedNumbers {
  friendly_name: string;
  phone_number: string;
  sid: string;
  voice_application_sid: string;
}

@Component({
  components: {CreateIncomingPhoneNumberModal}
})
export default class ApplyNumbers extends Vue {
  @Prop() public numbers!: Array<AppliedNumbers>;

  private number = new RestcommNumbers();

  private message = new ResponseMessenger();

  private applyPanel = false;

  openApplyPanel(){
    this.applyPanel = true;
  }

  closeApplyPanel() {
    this.applyPanel = false;
  }

  releaseNumber(sid: string) {
    this.number.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    this.number.update(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID))
        , sid, null, null, null, null, null, null, '')
        .then(response => {
          console.log(response.data);
          alert('電話番号の割り当てを解除しました。');
          this.updateAppliedNumbers();
        })
        .catch(error => {
          console.log(error.response);
          this.message.parseMessageResponse(error.response);
          alert(this.message.getTextMessage());
        })
  }

  @Emit('applied_numbers')
  updateAppliedNumbers() {
    console.log('e');
  }
}
